import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { func } from 'prop-types'
import { updateAngle } from '../../../../../store/Actions/MapActions'

class Angle extends PureComponent {
  componentDidMount = () => {
    if (window.DeviceOrientationEvent) {
      window.addEventListener('deviceorientation', this.angleListener, true)
    }
  }

  angleListener = event => {
    this.props.updateAngle(event.alpha)
  }

  componentWillUnmount = () => {
    window.removeEventListener('deviceorientation', this.angleListener)
  }

  render() {
    return null
  }
}

Angle.propTypes = {
  updateAngle: func.isRequired,
}

const mapStateToProps = ({ map }) => ({
  angle: map.angle,
})

const mapDispatchToProps = dispatch => ({
  updateAngle: value => dispatch(updateAngle(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Angle)



// WEBPACK FOOTER //
// ./src/components/Elements/DeviceEvents/Angle/AngleComponent/index.jsx